import React from "react";
import { Box, Image, useBreakpointValue } from "@chakra-ui/react";

function Hero() {
  // Define the image source based on the viewport width
  const imageSrc = useBreakpointValue({
    base: "https://leadguitar.s3.eu-north-1.amazonaws.com/images/logomini2.png",
    md: "https://leadguitar.s3.eu-north-1.amazonaws.com/images/logomini.png",
  });

  return (
    <Box
      className="logo-container"
      position="relative"
      width="100%"
      height={{ 
        base: "7.3rem",   
        md: "14rem",     
        lg: "45dvh",     
        xl: "56dvh"    
      }}
      zIndex="1"
    >
      <Image
        src={imageSrc} 
        width="100%"
        height="100%"
        objectFit="cover"
        objectPosition="bottom"
        alt="logo leadguitar"
      />
    </Box>
  );
}

export default Hero;
